<template>
  <section class="cafes-theologiques">

    

    <p class="intro">
      L’EITP promeut des formations spécifiques pour le renforcement des compétences (formations aux aumôniers, responsables de groupes, membres des conseils pastoraux paroissiaux) et des formations générales sur des thèmes spirituels (ouvertes à tous) pour l’enracinement de la foi et dans une perspective apologétique. Ces formations sont payantes et s’étendent sur trois ou quatre séances au plus. 
Les Cafés théologiques sont ouverts aux apprenants de l’école, selon des conditions particulières. Certains peuvent en profiter pour des rattrapages de cours selon que le thème abordé est en lien avec un module de cours. 

    </p>

    <div>


      <div
  v-for="(event, eIndex) in articles"
  :key="eIndex"
  class="event-card"
>
  <!-- IMAGE À GAUCHE -->
  <div class="event-image">
    <img
      v-if="event.urlImage"
      :src="getUrlApiForFiles(event.urlImage)"
      alt="image"
    />
    <div v-else class="no-image">
      Aucune image
    </div>
  </div>

  <!-- CONTENU À DROITE -->
  <div class="event-content">
    <h3 class="event-title">{{ event.titre }}</h3>
    <p class="event-subtitle">{{ event.sousTitre }}</p>

    <div
      class="event-description"
      v-html="event.contenu"
    ></div>
  </div>
      </div>

    </div>
     <div class="">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
    </div>
  </section>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'DiesAcademicus',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/46?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
.cafes-theologiques {
  padding: 2.5rem;
}

.main-title {
  text-align: center;
  margin-bottom: 1rem;
}

.intro {
  text-align: center;
  max-width: 900px;
  margin: 0 auto 3rem;
  color: #555;
}

.year-title {
  margin: 2rem 0 1rem;
  color: #2c3e50;
}

.event-card {
  display: flex;
  align-items: stretch;
  gap: 2rem;
  margin-bottom: 2rem;
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.event-card:hover {
  transform: translateY(-5px);
}

/* IMAGE */
.event-image {
  flex: 0 0 300px;
  height: 220px;
}

.event-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Si pas d’image */
.no-image {
  width: 100%;
  height: 100%;
  background: #f4f6f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-weight: 500;
}

/* CONTENU */
.event-content {
  flex: 1;
  padding: 1.5rem;
}

.event-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.event-subtitle {
  font-size: 0.95rem;
  color: #64748b;
  margin-bottom: 1rem;
}

.event-description {
  color: #444;
  line-height: 1.6;
}

</style>
